import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Button from "../../../components/button/Button";
import styles from "../ricercaNav/RicercaNav.module.css"
import Utils from "../../../utils/Utils";
import Calendar from "../../../components/calendar/Calendar";
import RadioButton from "../../../components/radiobutton/RadioButton";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";
import $ from 'jquery';
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import Ruoli from "../../../utils/Ruoli.json";


class ExportSegnalazioniNav extends Component {

    state = {
        malattie: JSON.parse(sessionStorage.getItem("malattieExport")),
        malattieUtenteLaboratorio: JSON.parse(sessionStorage.getItem("malattieUtenteLaboratorio")),
        tipoData: "",
        dataDa: "",
        dataA: ""
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.riceviValoreMultiselect = this.riceviValoreMultiselect.bind(this)
    }

    componentDidMount() {
        let stato = this.props.filtri.stato

        if (stato) {

            stato["malattia"] = []
            stato["tipoData"] = ""

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState != this.state) {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }

    riceviValoreMultiselect(event, field) {
        let stato = this.props.filtri.stato
        let selectedMalattie = []
        for (let i = 0; i < event.currentTarget.selectedOptions.length; i++) {
            selectedMalattie[i] = event.currentTarget.selectedOptions[i].value
        }
        stato[field] = selectedMalattie


        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})
        this.setState({[field]: stato[field]})
    }

    riceviValore(field, event) {
        let stato = this.props.filtri.stato

        if (event) {
            if (event.target.value === "true") {
                stato[field] = true
                this.setState({[field]: true})
            } else if (event.target.value === "false") {
                stato[field] = false
                this.setState({[field]: false})
            } else {
                stato[field] = event.target.value
                this.setState({[field]: event.target.value})
            }
        } else {
            stato[field.currentTarget.id] = [field.currentTarget.value];
        }

        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})

    }

    render() {

        return (
            this.props.filtri.rows ?
            <div className={"row"} style={{ paddingBottom:"1rem", width:"55%"}}>
                <div className={"col-6"}>
                    <p id={"title"} style={{fontWeight: "bold", marginTop: "1rem"}}>{"Periodo di riferimento"}</p>
                    <div className={"row"} style={{marginTop: "0.5rem"}}>
                        <div className={"col-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id}
                                      value={this.state.dataDa}
                                      field={this.props.filtri.rows["data"].field}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder ? this.props.filtri.rows["data"].placeholder : ""}
                                      errorMessage={this.state.dataDa && Utils.isDateInValid(this.state.dataDa) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataDa), "-") &&
                                      this.state.dataDa !== ""} />
                        </div>
                        <div className={"col-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id1}
                                      value={this.state.dataA}
                                      field={this.props.filtri.rows["data"].fieldRadio}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder1 ? this.props.filtri.rows["data"].placeholder1 : ""}
                                      errorMessage={this.state.dataA && Utils.isDateInValid(this.state.dataA) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataA), "-") &&
                                      this.state.dataA !== ""}/>

                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id1}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di inizio sintomi"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={true}
                                         checked={this.state.tipoData === true}
                            ></RadioButton>
                        </div>
                        <div className={"col-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id2}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di segnalazione"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={false}
                                         checked={this.state.tipoData === false}
                            ></RadioButton>
                        </div>
                    </div>
                </div>
                <div className={"col-6"}>
                    <p id={"title"} style={{fontWeight: "bold", marginTop: "1rem"}}>{"Malattia"}</p>
                    <div style={{marginTop: "0.5rem"}}>
                        <SelectAutocomplete
                            id={this.props.filtri.rows["malattia"].id}
                            field={this.props.filtri.rows["malattia"].field}
                            multiple={"true"}
                            onChange={(e) => this.riceviValoreMultiselect(e, this.props.filtri.rows["malattia"].field)}
                            functionMap={(SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione ? this.state.malattieUtenteLaboratorio : this.state.malattie).map((oggetto) => {
                                return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                            })}
                            ricerca={true}>
                        </SelectAutocomplete>
                    </div>
                    <div className={"row"} style={{display:"grid", justifyContent:"center"}}>
                        <Button className="btnBlu" id={"visualizza"}
                                text={"Richiedi export"}
                                onClick={this.props.filtri.applicaFiltri}
                                style={{height: "2rem", width: "15rem", marginTop:"0.5rem"}}>
                        </Button>
                    </div>
                </div>
            </div>: <></>
        );
    }

}

export default withTranslation('common')(ExportSegnalazioniNav);